import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';

import { Observable, BehaviorSubject } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';

import { CookieService } from 'ngx-cookie-service';

//import { Task } from '../classes/task';
 
const httpOptions = {
  headers: new HttpHeaders(
    { 
      'Content-Type': 'application/json'
    }
  )
};

export interface Leader {
  name: string;
  wins: number;
  losses: number;
  win_percentage: number;
}

@Injectable()
export class TasksService {

  private baseUrl = environment.apiUrl;

  constructor(
    private http: HttpClient, private router: Router, private cookieService: CookieService
  ) { }

  getTask (id) {
    return this.http.get(this.baseUrl + '/tasks/' + id, httpOptions).subscribe(
      (data: Response) => {
        return data;
      },
      error => {
        console.log(JSON.stringify(error));
      });
  }

  getUserTasksByDay (userId, day) {
    let httpOptions = { headers: new HttpHeaders( { 'Content-Type': 'application/json', 'Token': this.cookieService.get('perchedToken') } ) };
    var filter = '?startDate=' + day + '&endDate=' + day;
    return this.http.get(this.baseUrl + '/users/' + userId + '/tasks' + filter, httpOptions);
  }

  addTask (task) {
    let httpOptions = { headers: new HttpHeaders( { 'Content-Type': 'application/json', 'Token': this.cookieService.get('perchedToken') } ) };
    return this.http.post(this.baseUrl + '/tasks', task, httpOptions);
  }

  deleteTask (taskId) {
    let httpOptions = { headers: new HttpHeaders( { 'Content-Type': 'application/json', 'Token': this.cookieService.get('perchedToken') } ) };
    return this.http.delete(this.baseUrl + '/tasks/' + taskId, httpOptions);
  }

  updateTaskStatus (taskId, taskStatus) {
    let httpOptions = { headers: new HttpHeaders( { 'Content-Type': 'application/json', 'Token': this.cookieService.get('perchedToken') } ) };
    return this.http.patch(this.baseUrl + '/tasks/' + taskId, {"status": taskStatus}, httpOptions);
  }

  getResultsByDate (userId, startDate, endDate) {
    let httpOptions = { headers: new HttpHeaders( { 'Content-Type': 'application/json', 'Token': this.cookieService.get('perchedToken') } ) };
    var filter = '?startDate=' + startDate + '&endDate=' + endDate;
    return this.http.get(this.baseUrl + '/results/' + userId + filter,  httpOptions);
  }

  getDailyResults (userId, startDate, endDate) {
    let httpOptions = { headers: new HttpHeaders( { 'Content-Type': 'application/json', 'Token': this.cookieService.get('perchedToken') } ) };
    var filter = '?startDate=' + startDate + '&endDate=' + endDate;
    return this.http.get(this.baseUrl + '/users/' + userId + '/results' + filter,  httpOptions);
  }

  getMonthlyUserLeaderboard (userId) {
    let httpOptions = { headers: new HttpHeaders( { 'Content-Type': 'application/json', 'Token': this.cookieService.get('perchedToken') } ) };
    return this.http.get(this.baseUrl + '/users/' + userId + '/leaderboard/month', httpOptions);
  }

  getYearlyUserLeaderboard (userId) {
    let httpOptions = { headers: new HttpHeaders( { 'Content-Type': 'application/json', 'Token': this.cookieService.get('perchedToken') } ) };
    return this.http.get(this.baseUrl + '/users/' + userId + '/leaderboard/year', httpOptions);
  }

  getAllTimeUserLeaderboard (userId) {
    let httpOptions = { headers: new HttpHeaders( { 'Content-Type': 'application/json', 'Token': this.cookieService.get('perchedToken') } ) };
    return this.http.get(this.baseUrl + '/users/' + userId + '/leaderboard/all', httpOptions);
  }

}


// WEBPACK FOOTER //
// /Users/cullenkirkpatrick/Documents/Goals/goal-project/src/app/services/tasks.service.ts